import { render } from "./LesPelerinages.vue?vue&type=template&id=4965453c&scoped=true&ts=true"
import script from "./LesPelerinages.vue?vue&type=script&lang=ts"
export * from "./LesPelerinages.vue?vue&type=script&lang=ts"

import "./LesPelerinages.vue?vue&type=style&index=0&id=4965453c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4965453c"]])

export default __exports__